import React from "react";

export default function Banner() {
  return (
    <div className="relative bg-white overflow-hidden">
      <div className="pt-16 pb-80 sm:pt-24 sm:pb-40 lg:pt-40 lg:pb-48">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 sm:static">
          <div className="sm:max-w-lg">
            <h1 className="text-4xl font font-extrabold tracking-tight text-gray-900 sm:text-6xl">
              Your best stop for all MITTI wares.
            </h1>
            <p className="mt-4 text-xl text-gray-500">
              A collection of beautiful clay products that make life more
              sustainable. Find India's best organic kitchenware products for
              your home.
            </p>
          </div>
          <div>
            <div className="mt-10">
              {/* Decorative image grid */}
              <div
                aria-hidden="true"
                className="pointer-events-none lg:absolute lg:inset-y-0 lg:max-w-7xl lg:mx-auto lg:w-full"
              >
                <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                  <div className="flex items-center space-x-6 lg:space-x-8">
                    <div className="flex-shrink-0 grid grid-cols-1 gap-y-6 lg:gap-y-8">
                      <div className="w-44 h-64 rounded-lg overflow-hidden sm:opacity-0 lg:opacity-100">
                        <img
                          src="https://theotherperspectives.com/wp-content/uploads/2021/05/hands-1283149_1280-1024x682.jpg"
                          alt=""
                          className="w-full h-full object-center object-cover"
                        />
                      </div>
                      <div className="w-44 h-64 rounded-lg overflow-hidden">
                        <img
                          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ36PQuqmrvrUqA48MH_hTDe4CgSC1Qj48tFkygMWm_pESPfscEr-QOmbWtm1KZ-DfjszQ&usqp=CAU"
                          alt=""
                          className="w-full h-full object-center object-cover"
                        />
                      </div>
                    </div>
                    <div className="flex-shrink-0 grid grid-cols-1 gap-y-6 lg:gap-y-8">
                      <div className="w-44 h-64 rounded-lg overflow-hidden">
                        <br />
                        <br />
                        <br />
                        <img
                          src="https://4.imimg.com/data4/NW/MH/ANDROID-23660541/product-500x500.jpeg"
                          alt=""
                          className="w-full h-full rounded-lg object-center object-cover"
                        />
                      </div>
                      <div className="w-44 h-64 rounded-lg overflow-hidden">
                        <img
                          src="https://www.diethelmtravel.com/wp-content/uploads/2016/05/Pottery-Making-in-Weerawila_Fotolia_76251877_Subscription_Monthly_M-2.jpg"
                          alt=""
                          className="w-full h-full object-center object-cover"
                        />
                      </div>
                      <div className="w-44 h-64 rounded-lg overflow-hidden">
                        <img
                          src="https://img.grouponcdn.com/deal/kCvKGj1Wi5cGpYmSCkwj/CG-2048x1242/v1/c870x524.jpg"
                          alt=""
                          className="w-full h-full object-center object-cover"
                        />
                      </div>
                    </div>
                    <div className="flex-shrink-0 grid grid-cols-1 gap-y-6 lg:gap-y-8">
                      <div className="w-44 h-64 rounded-lg overflow-hidden">
                        <img
                          src="https://5.imimg.com/data5/YY/CW/MY-77368971/teracotta-classes-available-500x500.jpg"
                          alt=""
                          className="w-full h-full object-center object-cover"
                        />
                      </div>
                      <div className="w-44 h-64 rounded-lg overflow-hidden">
                        <img
                          src="https://static.toiimg.com/thumb/88057495.cms?width=680&height=512&imgsize=83900"
                          alt=""
                          className="w-full h-full object-center object-cover"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <a
                href="/"
                className="inline-block text-center bg-indigo-600 border border-transparent rounded-md py-3 px-8 font-medium text-white hover:bg-indigo-700"
              >
                Contact To Kashi ❤️ 
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
